import { useEffect, useRef } from 'react';

export const useSessionPersistence = () => {
  const navigationCount = useRef(0);
  const lastNavigationTime = useRef(Date.now());

  useEffect(() => {
    const handleBeforeUnload = () => {
      console.log('🔍 SessionPersistence: Browser navigation detected');
      // Store navigation state
      sessionStorage.setItem('lastNavigation', Date.now().toString());
    };

    const handlePopState = (event) => {
      console.log('🔍 SessionPersistence: Pop state detected');
      navigationCount.current++;
      lastNavigationTime.current = Date.now();
      
      // Check if this is a back/forward navigation
      const timeSinceLastNav = Date.now() - lastNavigationTime.current;
      if (timeSinceLastNav < 1000) {
        console.log('🔍 SessionPersistence: Rapid navigation detected, preserving session');
        // Don't trigger validation for rapid navigation
        return;
      }
    };

    const handleVisibilityChange = () => {
      if (!document.hidden) {
        console.log('🔍 SessionPersistence: Page became visible');
        // Page is back in focus, but don't re-validate immediately
      }
    };

    // Listen for browser navigation events
    window.addEventListener('beforeunload', handleBeforeUnload);
    window.addEventListener('popstate', handlePopState);
    document.addEventListener('visibilitychange', handleVisibilityChange);

    return () => {
      window.removeEventListener('beforeunload', handleBeforeUnload);
      window.removeEventListener('popstate', handlePopState);
      document.removeEventListener('visibilitychange', handleVisibilityChange);
    };
  }, []);

  // Check if we're in a navigation scenario
  const isNavigating = () => {
    const lastNav = sessionStorage.getItem('lastNavigation');
    if (!lastNav) return false;
    
    const timeSinceNav = Date.now() - parseInt(lastNav);
    return timeSinceNav < 5000; // Within 5 seconds of navigation
  };

  return { isNavigating };
}; 